import React from 'react';
import './css/research.css';

export default function Research() {
  return (
    <div className="container " id="research">
      <h1 className="p-4">Research</h1>
      <div
        className="card d-flex justify-content-center"
        style={{ width: '80%' }}
      >
        <div className="researchImage p-3">
          <img
            src="assets/Image_without_bg.png"
            className="card-img-top"
            alt="..."
            style={{ width: '13%', height: '13%', borderRadius: '50px' }}
          />
        </div>
        <div className="card-body">
          <h5 className="card-title">Research Enthusiast</h5>
          <p className="card-text">
            I am a very detail-oriented professional with expertise in
            research.Here is the link to check out my research.
          </p>
          <a
            href="https://scholar.google.com/citations?hl=en&user=3Fy31SgAAAAJ"
            rel="noreferrer"
            target="_blank"
            className="btn btn-primary"
          >
            Research Profile <i className="bi bi-box-arrow-up-right"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
